/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const timesheetProjectDtoSchema = z.object({
  customerId: z.coerce.number().int(),
  customerName: z.coerce.string(),
  projectId: z.coerce.number().int().nullable().nullish(),
  projectName: z.coerce.string(),
});
